import axios from "axios";

export const api_instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});
export const api_instance_auth = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

api_instance_auth.interceptors.request.use((config) => {
  config.headers["Authorization"] = `Bearer ${localStorage.accessToken}`;
  return config;
});

api_instance_auth.interceptors.response.use(
  (response) => response, // Pass through successful responses
  (error) => {
    if (error.response) {
      // Access error.response explicitly
      const { status, data } = error.response;

      switch (status) {
        case 301: // Redirect to login page
        case 401: // Unauthorized
          localStorage.removeItem("accessToken");
          localStorage.removeItem("role");
          window.location.replace("/login");
          break;
        case 403: // Forbidden
          localStorage.removeItem("accessToken");
          localStorage.removeItem("role");
          window.location.replace("/login");
          break;
        // case 404: // Not found
        //   console.error("Resource not found", data);
        //   window.location.href = "/404";
        //   break;
        // case 500: // Internal server error
        //   console.error("Server error", data);
        //   window.location.href = "/500";
        //   break;
        default:
          console.error(`Unhandled status code: ${status}`, data);
        // window.location.href = "/404";
      }
    } else {
      // Handle network or other errors
      console.error("Network error or no response");
    }

    // Reject the promise to allow further handling
    return Promise.reject(error);
  }
);
